(function () {
  function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  function pickVideoSrc(root, isDesktop) {
    const webm = isDesktop ? root.dataset.desktopWebm : root.dataset.mobileWebm;
    const mov = isDesktop ? root.dataset.desktopMov : root.dataset.mobileMov;

    // Never cross-load formats: Safari → MOV only, others → WebM only
    if (isSafari()) return mov || '';
    return webm || '';
  }

  function preloadVideo(src) {
    if (!src || document.querySelector('link[data-main-banner-video-preload="' + src + '"]')) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'video';
    link.href = src;
    link.setAttribute('data-main-banner-video-preload', src);
    document.head.appendChild(link);
  }

  function mount(root) {
    const video = root.querySelector('video');
    if (!video) return;

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const safari = isSafari();
    const nextKey = (isDesktop ? 'desktop' : 'mobile') + (safari ? '-safari' : '-webm');
    const src = pickVideoSrc(root, isDesktop);

    if (root.dataset.activeKey === nextKey) return;
    root.dataset.activeKey = nextKey;

    root.classList.remove('is-video', 'is-fallback');

    if (src) {
      root.classList.add('is-video');
      preloadVideo(src);
      if (video.dataset.currentSrc !== src) {
        video.dataset.currentSrc = src;
        video.src = src;
        video.load();
      }
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
      return;
    }

    root.classList.add('is-fallback');
    video.removeAttribute('src');
    video.removeAttribute('data-current-src');
    video.load();
  }

  function initRoot(root) {
    mount(root);

    const mq = window.matchMedia('(min-width: 750px)');
    const onChange = () => {
      root.dataset.activeKey = '';
      mount(root);
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  function init() {
    document
      .querySelectorAll('[data-transparent-cdn-video], .main-banner__transparent-media')
      .forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
